import React, { Component } from "react";
import {
  Grid,
  Header,
  Button,
  Form,
  Input,
  Transition, 
  Message
} from "semantic-ui-react";
import axios from "axios";
import { Config } from "../../../data/config";
import classNames from "classnames";
import {connect} from 'react-redux';
import { displayError, resetError } from "../../../store/actions/error";
import ErrorMessage from "../../error-message/ErrorMessage";
import { Loader } from '../../Loader/Loader';
import ReCAPTCHA from "react-google-recaptcha";


class Step5 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
      submitting: false,
      errors: {},
      serverErrors: {},
      isLoading: false,
      isReCaptchaSelected: false,
    };
    this.transitionBack = this.transitionBack.bind(this);
    this.transitionNext = this.transitionNext.bind(this);
    this.sendRequest = this.sendRequest.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onReCaptchaChange = this.onReCaptchaChange.bind(this);
    this.recaptchaRef = null;

  }

  componentDidMount() {
    this.setState({
      visible: true
    });
  }

  transitionBack() {
    const { setServiceAvailable } = this.props;

    this.setState({
      animation: "fade left",
      visible: !this.state.visible
    });
    setTimeout(() => {
      setServiceAvailable(null, "fade right");
    }, 400);
  }

  getData() {
    return {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      email: this.state.email,
      address: this.props.address,
      bid: this.props.bid,
      unit: this.props.unitNo
    };
  }

  joinWaitingList()
  {
    const { resetError, displayError } = this.props;

    resetError();

      axios
        .post(`${Config.frontApiUrl}/availability/waitinglist`, this.getData())
        .then(response => {
          this.transitionNext();
        })
        .catch(error => {
          // const errors = getFormattedErrors(error.response.data.error) || {};
          this.setState({
            // serverErrors: errors,
            submitted: false,
            isLoading: false
          });
          displayError();
        });
  }

  sendRequest() {

    const errors = this.validate();
    if (Object.keys(errors).length) {
      this.setState({
        errors: errors
      });
    } else {
      this.setState({
        submitted: true,
        errors: {},
        isLoading: true
      });
      this.recaptchaRef.execute();
    }
  }

  transitionNext() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade right",
      visible: false
    });
    setTimeout(() => {
      changeStep(6, "fade left");
    }, 400);
  }

  onChange(e, data) {
    this.setState({
      [data.name]: data.value
    });
  }

  validate() {
    const errors = {};
    const { first_name, last_name, email } = this.state;
    if (!first_name) {
      errors["first_name"] = "First name is required";
    }
    if (!last_name) {
      errors["last_name"] = "Last name is required";
    }
    if (!email) {
      errors["email"] = "Email is required";
    }
    return errors;
  }

  onReCaptchaChange(value) {
    if (value) {
      this.setState({ isReCaptchaSelected: true });
      this.joinWaitingList();
    }
  }

  render() {
    const { visible, animation, submitting, errors, serverErrors, isLoading } = this.state;

    return (
      <div>
        <div className="back--icon" onClick={this.transitionBack} />
        <Transition visible={visible} duration={500} animation={animation}>
          <div>
            <Header className="title__main" as="h1" textAlign="center">
              Coming Soon
            </Header>
            <Header.Subheader className="text-black">
              Enter your info below to know as soon as service is active at
              your address.
            </Header.Subheader>
            <Grid className="form__signup width__xs">
              <Grid.Row className="py-0">
                <Grid.Column className="px-0">
                  <Form>
                    <Form.Group widths="equal">
                      <Form.Field
                        className={classNames({
                          "is-error": errors.first_name
                        })}
                      >
                        <Input
                          placeholder="First Name"
                          labelPosition="right"
                          label={
                            <div className="label__text">
                              First Name
                            </div>
                          }
                          name="first_name"
                          onChange={this.onChange}
                          {...errors.first_name && {
                            color: "red",
                            icon: "exclamation triangle"
                          }}
                        />
                        {errors.first_name && (
                          <div className="error-text">{errors.first_name}</div>
                        )}
                      </Form.Field>
                      <Form.Field
                        className={classNames({
                          "is-error": errors.last_name
                        },
                      "mt-0")}
                      >
                        <Input
                          placeholder="Last Name"
                          labelPosition="right"
                          label={
                            <div className="label__text">
                              Last Name
                            </div>
                          }
                          name="last_name"
                          onChange={this.onChange}
                          {...errors.last_name && {
                            color: "red",
                            icon: "exclamation triangle"
                          }}
                        />
                        {errors.last_name && (
                          <div className="error-text">{errors.last_name}</div>
                        )}
                      </Form.Field>
                    </Form.Group>
                    <Form.Field
                      className={classNames({
                        "is-error": errors.email
                      })}
                    >
                      <Input
                        placeholder="Email"
                        labelPosition="right"
                        type="email"
                        label={
                          <div className="label__text">Email</div>
                        }
                        name="email"
                        onChange={this.onChange}
                        {...errors.email && {
                          color: "red",
                          icon: "exclamation triangle"
                        }}
                      />
                      {errors.email && (
                        <div className="error-text">{errors.email}</div>
                      )}
                    </Form.Field>
                    {Object.keys(serverErrors).length > 0 && (
                      <div className="field is-error radius--full">
                        {serverErrors.code === 422 ? (
                          Object.keys(serverErrors.fields).map(value => (
                            <div className="error-text" key={value}>
                              {serverErrors.fields[value]}
                            </div>
                          ))
                        ) : (
                          <div className="error-text">
                            {serverErrors.message}
                          </div>
                        )}
                      </div>
                    )}

                    { isLoading ?  <Loader /> : <Button
                      size="medium"
                      disabled={submitting}
                      className="btn--full"
                      onClick={this.sendRequest}
                    >
                      {" "}
                      {submitting ? "Sending..." : "Send Request"}{" "}
                    </Button>
                    }
                    <Form.Field>
                           <div className="section__recaptcha centered mt-7">
                          <ReCAPTCHA
                            ref={(ref) => this.recaptchaRef = ref}
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                            size="invisible"
                            onChange={this.onReCaptchaChange}
                            className="g-recaptcha"
                          />
                        {errors.recaptcha &&
                          <Message error visible className="captcha-error">
                            <Header as="h5" textAlign="center">
                            {errors.recaptcha}
                            </Header>
                          </Message>
                        }
                      </div>
             
                      <ErrorMessage />
                    </Form.Field>
                  </Form>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Transition>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    address : state.connection.address,
    bid: state.connection.bid,
    unitNo: state.connection.unitNo
  }
}

const mapDispatchToProps = dispatch => {
  return {
    resetError: () => dispatch(resetError()),
    displayError: () => dispatch(displayError())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Step5);



// WEBPACK FOOTER //
// ./src/components/check-availability/service-not-available/Step5.js